<template>
    <div class="o-buy-ticket-modal">
        <div
            v-if="isLoading"
            class="buy-ticket-modal-loader"
        >
            <img
                src="../../../assets/images/loaders/loader-black.svg"
                class="buy-ticket-modal-loader-image"
            >
        </div>
        <span class="buy-ticket-modal-title">
            {{ obj.title}}
        </span>
        <span class="buy-ticket-modal-date">
            {{ obj.date}}  {{ obj.time}}
        </span>
        <span class="buy-ticket-modal-screen">
            {{ obj.screen }}
        </span>
        <div
            ref="qr"
            class="buy-ticket-modal-qr-container"
        />
        <span class="buy-ticket-modal-tip">
            {{ $t('o-movie-schedule.scan-qr') }}
        </span>
        <button
            type="button"
            class="buy-ticket-modal-close-button"
            @click.capture="closeModal"
        >
            <svg-icon
                original
                name="icons/close"
                class="buy-ticket-modal-close-icon"
            />
        </button>
    </div>
</template>

<script>
import qrcode from "qrcode-generator";

export default {
    name: 'OBuyTicketModal',
    data() {
        return {
            showModal: false,
            config: null,
            isLoading: false,
            generateQrTimeout: 1000
        }
    },
    props: {
        obj: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.generateQr();
    },
    methods: {
        generateQr() {
            this.isLoading = true;

            setTimeout(() => {
                try {
                    const typeNumber = 0;
                    const errorCorrectionLevel = 'L';
                    const qr = qrcode(typeNumber, errorCorrectionLevel);
                    qr.addData(this.obj.url);
                    qr.make();
                    this.$refs.qr.innerHTML = qr.createSvgTag({ cellSize:3.5, margin: 0});
                } catch(error) {
                    console.warn();
                } finally {
                    this.isLoading = false;
                }
            }, this.generateQrTimeout);
        },
        closeModal() {
            this.$emit('onClose');
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
